export type SearchFields<T> = {
  /** De criteriumnaam; wordt altijd doorzocht. */
  getName: (item: T) => string;
  /** Extra tekst die op dezelfde plek al getoond wordt, bijv. gevonden waarde of code. */
  getValues?: (item: T) => (string | null | undefined)[];
};

/** Lege-staattekst, gedeeld door alle plekken met een criteria-zoekveld. */
export const CRITERIA_SEARCH_EMPTY_TITLE = 'Geen criteria gevonden';

/**
 * Filtert op een zoekterm: hoofdletterongevoelig, spaties aan begin en eind
 * genegeerd, deelmatch op de naam en optioneel op bijbehorende tekst.
 * Een lege zoekterm laat de lijst ongemoeid.
 */
export function filterByQuery<T>(
  items: readonly T[],
  query: string,
  fields: SearchFields<T>,
): T[] {
  const normalized = query.trim().toLowerCase();
  if (normalized === '') return [...items];

  return items.filter((item) => {
    if (fields.getName(item).toLowerCase().includes(normalized)) return true;
    const values = fields.getValues?.(item) ?? [];
    return values.some(
      (value) => typeof value === 'string' && value.toLowerCase().includes(normalized),
    );
  });
}
